import { Leaf } from "lucide-react";

const items = [
  "Sem dietas restritivas",
  "11 capítulos práticos",
  "Exercícios simples",
  "Reeducação real",
  "Checklist semanal",
  "Comida de verdade",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 -rotate-1 overflow-hidden bg-forest py-4 shadow-lg"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {items.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="mx-6 flex items-center gap-6 whitespace-nowrap font-serif text-lg italic text-cream/90 sm:text-xl"
              >
                {item}
                <Leaf size={15} className="text-ochre" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
